(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/brand_card', ['react'], factory) :
  (global = global || self, global['@fdn/brand_card'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b = "function" === typeof Symbol && Symbol["for"],
      c = b ? Symbol["for"]("react.element") : 60103,
      d = b ? Symbol["for"]("react.portal") : 60106,
      e = b ? Symbol["for"]("react.fragment") : 60107,
      f = b ? Symbol["for"]("react.strict_mode") : 60108,
      g = b ? Symbol["for"]("react.profiler") : 60114,
      h = b ? Symbol["for"]("react.provider") : 60109,
      k = b ? Symbol["for"]("react.context") : 60110,
      l = b ? Symbol["for"]("react.async_mode") : 60111,
      m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
      n = b ? Symbol["for"]("react.forward_ref") : 60112,
      p = b ? Symbol["for"]("react.suspense") : 60113,
      q = b ? Symbol["for"]("react.suspense_list") : 60120,
      r = b ? Symbol["for"]("react.memo") : 60115,
      t = b ? Symbol["for"]("react.lazy") : 60116,
      v = b ? Symbol["for"]("react.block") : 60121,
      w = b ? Symbol["for"]("react.fundamental") : 60117,
      x = b ? Symbol["for"]("react.responder") : 60118,
      y = b ? Symbol["for"]("react.scope") : 60119;

  function z(a) {
    if ("object" === _typeof(a) && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function A(a) {
    return z(a) === m;
  }

  var AsyncMode = l;
  var ConcurrentMode = m;
  var ContextConsumer = k;
  var ContextProvider = h;
  var Element = c;
  var ForwardRef = n;
  var Fragment = e;
  var Lazy = t;
  var Memo = r;
  var Portal = d;
  var Profiler = g;
  var StrictMode = f;
  var Suspense = p;

  var isAsyncMode = function isAsyncMode(a) {
    return A(a) || z(a) === l;
  };

  var isConcurrentMode = A;

  var isContextConsumer = function isContextConsumer(a) {
    return z(a) === k;
  };

  var isContextProvider = function isContextProvider(a) {
    return z(a) === h;
  };

  var isElement = function isElement(a) {
    return "object" === _typeof(a) && null !== a && a.$$typeof === c;
  };

  var isForwardRef = function isForwardRef(a) {
    return z(a) === n;
  };

  var isFragment = function isFragment(a) {
    return z(a) === e;
  };

  var isLazy = function isLazy(a) {
    return z(a) === t;
  };

  var isMemo = function isMemo(a) {
    return z(a) === r;
  };

  var isPortal = function isPortal(a) {
    return z(a) === d;
  };

  var isProfiler = function isProfiler(a) {
    return z(a) === g;
  };

  var isStrictMode = function isStrictMode(a) {
    return z(a) === f;
  };

  var isSuspense = function isSuspense(a) {
    return z(a) === p;
  };

  var isValidElementType = function isValidElementType(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };

  var typeOf = z;
  var reactIs_production_min = {
    AsyncMode: AsyncMode,
    ConcurrentMode: ConcurrentMode,
    ContextConsumer: ContextConsumer,
    ContextProvider: ContextProvider,
    Element: Element,
    ForwardRef: ForwardRef,
    Fragment: Fragment,
    Lazy: Lazy,
    Memo: Memo,
    Portal: Portal,
    Profiler: Profiler,
    StrictMode: StrictMode,
    Suspense: Suspense,
    isAsyncMode: isAsyncMode,
    isConcurrentMode: isConcurrentMode,
    isContextConsumer: isContextConsumer,
    isContextProvider: isContextProvider,
    isElement: isElement,
    isForwardRef: isForwardRef,
    isFragment: isFragment,
    isLazy: isLazy,
    isMemo: isMemo,
    isPortal: isPortal,
    isProfiler: isProfiler,
    isStrictMode: isStrictMode,
    isSuspense: isSuspense,
    isValidElementType: isValidElementType,
    typeOf: typeOf
  };

  var reactIs_development = createCommonjsModule(function (module, exports) {

    if (process.env.NODE_ENV !== "production") {
      (function () {
        // nor polyfill, then a plain number is used for performance.

        var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
        // (unstable) APIs that have been removed. Can we remove the symbols?

        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }

        function typeOf(object) {
          if (_typeof(object) === 'object' && object !== null) {
            var $$typeof = object.$$typeof;

            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;

                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;

                  default:
                    var $$typeofType = type && type.$$typeof;

                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;

                      default:
                        return $$typeof;
                    }

                }

              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }

          return undefined;
        } // AsyncMode is deprecated along with isAsyncMode


        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

              console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }

        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }

        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }

        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }

        function isElement(object) {
          return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }

        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }

        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }

        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }

        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }

        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }

        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }

        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  });
  var reactIs_development_1 = reactIs_development.AsyncMode;
  var reactIs_development_2 = reactIs_development.ConcurrentMode;
  var reactIs_development_3 = reactIs_development.ContextConsumer;
  var reactIs_development_4 = reactIs_development.ContextProvider;
  var reactIs_development_5 = reactIs_development.Element;
  var reactIs_development_6 = reactIs_development.ForwardRef;
  var reactIs_development_7 = reactIs_development.Fragment;
  var reactIs_development_8 = reactIs_development.Lazy;
  var reactIs_development_9 = reactIs_development.Memo;
  var reactIs_development_10 = reactIs_development.Portal;
  var reactIs_development_11 = reactIs_development.Profiler;
  var reactIs_development_12 = reactIs_development.StrictMode;
  var reactIs_development_13 = reactIs_development.Suspense;
  var reactIs_development_14 = reactIs_development.isAsyncMode;
  var reactIs_development_15 = reactIs_development.isConcurrentMode;
  var reactIs_development_16 = reactIs_development.isContextConsumer;
  var reactIs_development_17 = reactIs_development.isContextProvider;
  var reactIs_development_18 = reactIs_development.isElement;
  var reactIs_development_19 = reactIs_development.isForwardRef;
  var reactIs_development_20 = reactIs_development.isFragment;
  var reactIs_development_21 = reactIs_development.isLazy;
  var reactIs_development_22 = reactIs_development.isMemo;
  var reactIs_development_23 = reactIs_development.isPortal;
  var reactIs_development_24 = reactIs_development.isProfiler;
  var reactIs_development_25 = reactIs_development.isStrictMode;
  var reactIs_development_26 = reactIs_development.isSuspense;
  var reactIs_development_27 = reactIs_development.isValidElementType;
  var reactIs_development_28 = reactIs_development.typeOf;

  var reactIs = createCommonjsModule(function (module) {

    if (process.env.NODE_ENV === 'production') {
      module.exports = reactIs_production_min;
    } else {
      module.exports = reactIs_development;
    }
  });
  var reactIs_1 = reactIs.typeOf;
  var reactIs_2 = reactIs.isElement;
  var reactIs_3 = reactIs.isValidElementType;

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  var printWarning = function printWarning() {};

  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */


  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error; // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.

          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.');
              err.name = 'Invariant Violation';
              throw err;
            }

            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }

          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }

          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }
  /**
   * Resets warning cache when testing.
   *
   * @private
   */


  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };

  var checkPropTypes_1 = checkPropTypes;

  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  var printWarning$1 = function printWarning() {};

  if (process.env.NODE_ENV !== 'production') {
    printWarning$1 = function printWarning(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */

    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }
    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */


    var ANONYMOUS = '<<anonymous>>'; // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */

    /*eslint-disable no-self-compare*/

    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */


    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    } // Make `instanceof Error` still work for returned errors.


    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }

      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;

            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }

        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }

            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }

          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }

        var propValue = props[propName];

        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }

        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!reactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning$1('Invalid argument supplied to oneOf, expected an array.');
          }
        }

        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);

          if (type === 'symbol') {
            return String(value);
          }

          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }

        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }

        for (var key in propValue) {
          if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

            if (error instanceof Error) {
              return error;
            }
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (typeof checker !== 'function') {
          printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }

        for (var key in shapeTypes) {
          var checker = shapeTypes[key];

          if (!checker) {
            continue;
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        } // We need to check all keys in case some are required but missing from
        // props.


        var allKeys = objectAssign({}, props[propName], shapeTypes);

        for (var key in allKeys) {
          var checker = shapeTypes[key];

          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (_typeof(propValue)) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;

        case 'boolean':
          return !propValue;

        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }

          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);

          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;

            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;

                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;

        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      } // falsy value can't be a Symbol


      if (!propValue) {
        return false;
      } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      } // Fallback for non-spec compliant Symbols which are polyfilled.


      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    } // Equivalent of `typeof` but with special handling for array and regexp.


    function getPropType(propValue) {
      var propType = _typeof(propValue);

      if (Array.isArray(propValue)) {
        return 'array';
      }

      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }

      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }

      return propType;
    } // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.


    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }

      var propType = getPropType(propValue);

      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }

      return propType;
    } // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"


    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);

      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;

        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;

        default:
          return type;
      }
    } // Returns class name of the object, if any.


    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }

      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret_1) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod

      var throwOnDirectAccess = true;
      module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = factoryWithThrowingShims();
    }
  });

  function _interopDefaultLegacy(e) {
    return e && _typeof(e) === 'object' && 'default' in e ? e : {
      'default': e
    };
  }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  /*
  Based on Glamor's sheet
  https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
  */


  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var isProd = typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production";

  var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
  };

  var StyleSheet = /*#__PURE__*/function () {
    function StyleSheet(param) {
      var ref = param === void 0 ? {} : param,
          _name = ref.name,
          name = _name === void 0 ? "stylesheet" : _name,
          _optimizeForSpeed = ref.optimizeForSpeed,
          optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
      invariant$1(isString(name), "`name` must be a string");
      this._name = name;
      this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
      invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
      this._optimizeForSpeed = optimizeForSpeed;
      this._serverSheet = undefined;
      this._tags = [];
      this._injected = false;
      this._rulesCount = 0;
      var node = typeof window !== "undefined" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = node ? node.getAttribute("content") : null;
    }

    var _proto = StyleSheet.prototype;

    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
      invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
      invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
      this.flush();
      this._optimizeForSpeed = bool;
      this.inject();
    };

    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
      return this._optimizeForSpeed;
    };

    _proto.inject = function inject() {
      var _this = this;

      invariant$1(!this._injected, "sheet already injected");
      this._injected = true;

      if (typeof window !== "undefined" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name);
        this._optimizeForSpeed = "insertRule" in this.getSheet();

        if (!this._optimizeForSpeed) {
          if (!isProd) {
            console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
          }

          this.flush();
          this._injected = true;
        }

        return;
      }

      this._serverSheet = {
        cssRules: [],
        insertRule: function insertRule(rule, index) {
          if (typeof index === "number") {
            _this._serverSheet.cssRules[index] = {
              cssText: rule
            };
          } else {
            _this._serverSheet.cssRules.push({
              cssText: rule
            });
          }

          return index;
        },
        deleteRule: function deleteRule(index) {
          _this._serverSheet.cssRules[index] = null;
        }
      };
    };

    _proto.getSheetForTag = function getSheetForTag(tag) {
      if (tag.sheet) {
        return tag.sheet;
      } // this weirdness brought to you by firefox


      for (var i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].ownerNode === tag) {
          return document.styleSheets[i];
        }
      }
    };

    _proto.getSheet = function getSheet() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };

    _proto.insertRule = function insertRule(rule, index) {
      invariant$1(isString(rule), "`insertRule` accepts only strings");

      if (typeof window === "undefined") {
        if (typeof index !== "number") {
          index = this._serverSheet.cssRules.length;
        }

        this._serverSheet.insertRule(rule, index);

        return this._rulesCount++;
      }

      if (this._optimizeForSpeed) {
        var sheet = this.getSheet();

        if (typeof index !== "number") {
          index = sheet.cssRules.length;
        } // this weirdness for perf, and chrome's weird bug
        // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule


        try {
          sheet.insertRule(rule, index);
        } catch (error) {
          if (!isProd) {
            console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
          }

          return -1;
        }
      } else {
        var insertionPoint = this._tags[index];

        this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
      }

      return this._rulesCount++;
    };

    _proto.replaceRule = function replaceRule(index, rule) {
      if (this._optimizeForSpeed || typeof window === "undefined") {
        var sheet = typeof window !== "undefined" ? this.getSheet() : this._serverSheet;

        if (!rule.trim()) {
          rule = this._deletedRulePlaceholder;
        }

        if (!sheet.cssRules[index]) {
          // @TBD Should we throw an error?
          return index;
        }

        sheet.deleteRule(index);

        try {
          sheet.insertRule(rule, index);
        } catch (error) {
          if (!isProd) {
            console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
          } // In order to preserve the indices we insert a deleteRulePlaceholder


          sheet.insertRule(this._deletedRulePlaceholder, index);
        }
      } else {
        var tag = this._tags[index];
        invariant$1(tag, "old rule at index `" + index + "` not found");
        tag.textContent = rule;
      }

      return index;
    };

    _proto.deleteRule = function deleteRule(index) {
      if (typeof window === "undefined") {
        this._serverSheet.deleteRule(index);

        return;
      }

      if (this._optimizeForSpeed) {
        this.replaceRule(index, "");
      } else {
        var tag = this._tags[index];
        invariant$1(tag, "rule at index `" + index + "` not found");
        tag.parentNode.removeChild(tag);
        this._tags[index] = null;
      }
    };

    _proto.flush = function flush() {
      this._injected = false;
      this._rulesCount = 0;

      if (typeof window !== "undefined") {
        this._tags.forEach(function (tag) {
          return tag && tag.parentNode.removeChild(tag);
        });

        this._tags = [];
      } else {
        // simpler on server
        this._serverSheet.cssRules = [];
      }
    };

    _proto.cssRules = function cssRules() {
      var _this = this;

      if (typeof window === "undefined") {
        return this._serverSheet.cssRules;
      }

      return this._tags.reduce(function (rules, tag) {
        if (tag) {
          rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function (rule) {
            return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
          }));
        } else {
          rules.push(null);
        }

        return rules;
      }, []);
    };

    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
      if (cssString) {
        invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
      }

      var tag = document.createElement("style");
      if (this._nonce) tag.setAttribute("nonce", this._nonce);
      tag.type = "text/css";
      tag.setAttribute("data-" + name, "");

      if (cssString) {
        tag.appendChild(document.createTextNode(cssString));
      }

      var head = document.head || document.getElementsByTagName("head")[0];

      if (relativeToTag) {
        head.insertBefore(tag, relativeToTag);
      } else {
        head.appendChild(tag);
      }

      return tag;
    };

    _createClass(StyleSheet, [{
      key: "length",
      get: function get() {
        return this._rulesCount;
      }
    }]);

    return StyleSheet;
  }();

  function invariant$1(condition, message) {
    if (!condition) {
      throw new Error("StyleSheet: " + message + ".");
    }
  }

  function hash(str) {
    var _$hash = 5381,
        i = str.length;

    while (i) {
      _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */


    return _$hash >>> 0;
  }

  var stringHash = hash;

  var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
  };

  var cache = {};
  /**
   * computeId
   *
   * Compute and memoize a jsx id from a basedId and optionally props.
   */

  function computeId(baseId, props) {
    if (!props) {
      return "jsx-" + baseId;
    }

    var propsToString = String(props);
    var key = baseId + propsToString;

    if (!cache[key]) {
      cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }

    return cache[key];
  }
  /**
   * computeSelector
   *
   * Compute and memoize dynamic selectors.
   */


  function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g; // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).

    if (typeof window === "undefined") {
      css = sanitize(css);
    }

    var idcss = id + css;

    if (!cache[idcss]) {
      cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }

    return cache[idcss];
  }

  function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function (args) {
      var id = args[0];
      var css = args[1];
      return /*#__PURE__*/React__default["default"].createElement("style", {
        id: "__" + id,
        // Avoid warnings upon render with a key
        key: "__" + id,
        nonce: options.nonce ? options.nonce : undefined,
        dangerouslySetInnerHTML: {
          __html: css
        }
      });
    });
  }

  var StyleSheetRegistry = /*#__PURE__*/function () {
    function StyleSheetRegistry(param) {
      var ref = param === void 0 ? {} : param,
          _styleSheet = ref.styleSheet,
          styleSheet = _styleSheet === void 0 ? null : _styleSheet,
          _optimizeForSpeed = ref.optimizeForSpeed,
          optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
      this._sheet = styleSheet || new StyleSheet({
        name: "styled-jsx",
        optimizeForSpeed: optimizeForSpeed
      });

      this._sheet.inject();

      if (styleSheet && typeof optimizeForSpeed === "boolean") {
        this._sheet.setOptimizeForSpeed(optimizeForSpeed);

        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
      }

      this._fromServer = undefined;
      this._indices = {};
      this._instancesCounts = {};
    }

    var _proto = StyleSheetRegistry.prototype;

    _proto.add = function add(props) {
      var _this = this;

      if (undefined === this._optimizeForSpeed) {
        this._optimizeForSpeed = Array.isArray(props.children);

        this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);

        this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
      }

      if (typeof window !== "undefined" && !this._fromServer) {
        this._fromServer = this.selectFromServer();
        this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
          acc[tagName] = 0;
          return acc;
        }, {});
      }

      var ref = this.getIdAndRules(props),
          styleId = ref.styleId,
          rules = ref.rules; // Deduping: just increase the instances count.

      if (styleId in this._instancesCounts) {
        this._instancesCounts[styleId] += 1;
        return;
      }

      var indices = rules.map(function (rule) {
        return _this._sheet.insertRule(rule);
      }) // Filter out invalid rules
      .filter(function (index) {
        return index !== -1;
      });
      this._indices[styleId] = indices;
      this._instancesCounts[styleId] = 1;
    };

    _proto.remove = function remove(props) {
      var _this = this;

      var styleId = this.getIdAndRules(props).styleId;
      invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
      this._instancesCounts[styleId] -= 1;

      if (this._instancesCounts[styleId] < 1) {
        var tagFromServer = this._fromServer && this._fromServer[styleId];

        if (tagFromServer) {
          tagFromServer.parentNode.removeChild(tagFromServer);
          delete this._fromServer[styleId];
        } else {
          this._indices[styleId].forEach(function (index) {
            return _this._sheet.deleteRule(index);
          });

          delete this._indices[styleId];
        }

        delete this._instancesCounts[styleId];
      }
    };

    _proto.update = function update(props, nextProps) {
      this.add(nextProps);
      this.remove(props);
    };

    _proto.flush = function flush() {
      this._sheet.flush();

      this._sheet.inject();

      this._fromServer = undefined;
      this._indices = {};
      this._instancesCounts = {};
    };

    _proto.cssRules = function cssRules() {
      var _this = this;

      var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
        return [styleId, _this._fromServer[styleId]];
      }) : [];

      var cssRules = this._sheet.cssRules();

      return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
        return [styleId, _this._indices[styleId].map(function (index) {
          return cssRules[index].cssText;
        }).join(_this._optimizeForSpeed ? "" : "\n")];
      }) // filter out empty rules
      .filter(function (rule) {
        return Boolean(rule[1]);
      }));
    };

    _proto.styles = function styles(options) {
      return mapRulesToStyle(this.cssRules(), options);
    };

    _proto.getIdAndRules = function getIdAndRules(props) {
      var css = props.children,
          dynamic = props.dynamic,
          id = props.id;

      if (dynamic) {
        var styleId = computeId(id, dynamic);
        return {
          styleId: styleId,
          rules: Array.isArray(css) ? css.map(function (rule) {
            return computeSelector(styleId, rule);
          }) : [computeSelector(styleId, css)]
        };
      }

      return {
        styleId: computeId(id),
        rules: Array.isArray(css) ? css : [css]
      };
    };
    /**
    * selectFromServer
    *
    * Collects style tags from the document with id __jsx-XXX
    */


    _proto.selectFromServer = function selectFromServer() {
      var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return elements.reduce(function (acc, element) {
        var id = element.id.slice(2);
        acc[id] = element;
        return acc;
      }, {});
    };

    return StyleSheetRegistry;
  }();

  function invariant(condition, message) {
    if (!condition) {
      throw new Error("StyleSheetRegistry: " + message + ".");
    }
  }

  var StyleSheetContext = /*#__PURE__*/React.createContext(null);
  StyleSheetContext.displayName = "StyleSheetContext";

  function createStyleRegistry() {
    return new StyleSheetRegistry();
  }

  function StyleRegistry(param) {
    var configuredRegistry = param.registry,
        children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function () {
      return rootRegistry || configuredRegistry || createStyleRegistry();
    }),
        registry = ref[0];
    return /*#__PURE__*/React__default["default"].createElement(StyleSheetContext.Provider, {
      value: registry
    }, children);
  }

  function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
  } // Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
  // https://github.com/reactwg/react-18/discussions/110


  var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
  var defaultRegistry = typeof window !== "undefined" ? createStyleRegistry() : undefined;

  function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry(); // If `registry` does not exist, we do nothing here.

    if (!registry) {
      return null;
    }

    if (typeof window === "undefined") {
      registry.add(props);
      return null;
    }

    useInsertionEffect(function () {
      registry.add(props);
      return function () {
        registry.remove(props);
      }; // props.children can be string[], will be striped since id is identical
    }, [props.id, String(props.dynamic)]);
    return null;
  }

  JSXStyle.dynamic = function (info) {
    return info.map(function (tagInfo) {
      var baseId = tagInfo[0];
      var props = tagInfo[1];
      return computeId(baseId, props);
    }).join(" ");
  };

  var StyleRegistry_1 = StyleRegistry;
  var createStyleRegistry_1 = createStyleRegistry;
  var style = JSXStyle;
  var useStyleRegistry_1 = useStyleRegistry;
  var index = {
    StyleRegistry: StyleRegistry_1,
    createStyleRegistry: createStyleRegistry_1,
    style: style,
    useStyleRegistry: useStyleRegistry_1
  };

  var style$1 = index.style;

  var Desktop = function Desktop(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "jsx-2132174629" + " " + "brand-card"
    }, /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : props.reviews_url + "/brands/".concat(props.brand.slug, "?tab=products&page=1"),
      className: "jsx-2132174629" + " " + "brand-card-image"
    }, /*#__PURE__*/React.createElement("img", {
      src: !!props.brand_image ? props.brand_image : props.brand.image || 'https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/placeholder-no-brand-logo.png',
      className: "jsx-2132174629"
    })), /*#__PURE__*/React.createElement("div", {
      className: "jsx-2132174629" + " " + "brand-detail"
    }, /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : props.reviews_url + "/brands/".concat(props.brand.slug, "?tab=products&page=1"),
      id: props.element_id,
      className: "jsx-2132174629" + " " + "brand-name"
    }, !!props.brand_name ? props.brand_name : props.brand.name), /*#__PURE__*/React.createElement("p", {
      className: "jsx-2132174629" + " " + "brand-product-total"
    }, !!props.brand_total_products ? props.brand_total_products : props.brand.total_products, ' ', "products")), /*#__PURE__*/React.createElement(style$1, {
      id: "2132174629"
    }, ".brand-card.jsx-2132174629{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-transition:all .4s ease;transition:all .4s ease;opacity:1;cursor:pointer;}.brand-card.jsx-2132174629:hover{opacity:.6;}.brand-card-image.jsx-2132174629{width:35%;max-width:35%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:7px;border:1px solid #F4F6F8;max-height:60px;overflow:hidden;}.brand-card-image.jsx-2132174629 img.jsx-2132174629{max-width:calc(100% - 14px);}.brand-card.jsx-2132174629 .brand-detail.jsx-2132174629{width:calc(65% - 16px);max-width:calc(65% - 16px);margin-left:16px;}.brand-card.jsx-2132174629 .brand-detail.jsx-2132174629{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;}.brand-card.jsx-2132174629 .brand-name.jsx-2132174629{font-family:Poppins,sans-serif;font-style:normal;font-weight:600;font-size:16px;line-height:16px;color:#000;margin-bottom:8px;-webkit-text-decoration:none;text-decoration:none;display:block;}.brand-card.jsx-2132174629 .brand-product-total.jsx-2132174629{font-family:Roboto;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;color:#454F5B;margin:0;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlc2t0b3AuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNENTLEFBR3dCLEFBU0EsQUFJRCxBQVlrQixBQUlMLEFBTUwsQUFJYyxBQVliLFVBckNMLENBYkQsQUFTZixRQTBDb0IsSUF0QlMsQ0FmZCxJQVdmLEdBY29CLE1BYUMsWUFaSCxDQVZDLE1BdUJGLFNBWkEsRUFWakIsSUFJQSxBQW1CbUIsU0FaQSxLQXpDRixHQXNERCxTQVpILENBNUJRLElBeUNWLE1BWlMsR0FhcEIsZUFadUIsZ0JBM0NHLGtDQTRDVixjQUNoQixDQS9CeUIsT0FiYixVQUNLLGVBQ2pCLG1FQVljLFlBQ2EseUJBQ1QsZ0JBQ0EsZ0JBQ2xCIiwiZmlsZSI6ImRlc2t0b3AuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXHJcblxyXG5jb25zdCBEZXNrdG9wID0gKHByb3BzKSA9PiB7XHJcbiAgcmV0dXJuIChcclxuICAgIDxkaXYgY2xhc3NOYW1lPVwiYnJhbmQtY2FyZFwiPlxyXG4gICAgICA8YVxyXG4gICAgICAgIGhyZWY9e1xyXG4gICAgICAgICAgISFwcm9wcy5icmFuZF91cmxcclxuICAgICAgICAgICAgPyBwcm9wcy5icmFuZF91cmxcclxuICAgICAgICAgICAgOiBwcm9wcy5yZXZpZXdzX3VybCArXHJcbiAgICAgICAgICAgICAgYC9icmFuZHMvJHtwcm9wcy5icmFuZC5zbHVnfT90YWI9cHJvZHVjdHMmcGFnZT0xYFxyXG4gICAgICAgIH1cclxuICAgICAgICBjbGFzc05hbWU9XCJicmFuZC1jYXJkLWltYWdlXCJcclxuICAgICAgPlxyXG4gICAgICAgIDxpbWdcclxuICAgICAgICAgIHNyYz17XHJcbiAgICAgICAgICAgICEhcHJvcHMuYnJhbmRfaW1hZ2VcclxuICAgICAgICAgICAgICA/IHByb3BzLmJyYW5kX2ltYWdlXHJcbiAgICAgICAgICAgICAgOiBwcm9wcy5icmFuZC5pbWFnZSB8fFxyXG4gICAgICAgICAgICAgICAgJ2h0dHBzOi8vczMuYXAtc291dGhlYXN0LTEuYW1hem9uYXdzLmNvbS9hc3NldHMuZmVtYWxlZGFpbHkuY29tL3dlYi1hc3NldHMvcGxhY2Vob2xkZXItbm8tYnJhbmQtbG9nby5wbmcnXHJcbiAgICAgICAgICB9XHJcbiAgICAgICAgLz5cclxuICAgICAgPC9hPlxyXG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cImJyYW5kLWRldGFpbFwiPlxyXG4gICAgICAgIDxhXHJcbiAgICAgICAgICBocmVmPXtcclxuICAgICAgICAgICAgISFwcm9wcy5icmFuZF91cmxcclxuICAgICAgICAgICAgICA/IHByb3BzLmJyYW5kX3VybFxyXG4gICAgICAgICAgICAgIDogcHJvcHMucmV2aWV3c191cmwgK1xyXG4gICAgICAgICAgICAgICAgYC9icmFuZHMvJHtwcm9wcy5icmFuZC5zbHVnfT90YWI9cHJvZHVjdHMmcGFnZT0xYFxyXG4gICAgICAgICAgfVxyXG4gICAgICAgICAgaWQ9e3Byb3BzLmVsZW1lbnRfaWR9XHJcbiAgICAgICAgICBjbGFzc05hbWU9XCJicmFuZC1uYW1lXCJcclxuICAgICAgICA+XHJcbiAgICAgICAgICB7ISFwcm9wcy5icmFuZF9uYW1lID8gcHJvcHMuYnJhbmRfbmFtZSA6IHByb3BzLmJyYW5kLm5hbWV9XHJcbiAgICAgICAgPC9hPlxyXG4gICAgICAgIDxwIGNsYXNzTmFtZT1cImJyYW5kLXByb2R1Y3QtdG90YWxcIj5cclxuICAgICAgICAgIHshIXByb3BzLmJyYW5kX3RvdGFsX3Byb2R1Y3RzXHJcbiAgICAgICAgICAgID8gcHJvcHMuYnJhbmRfdG90YWxfcHJvZHVjdHNcclxuICAgICAgICAgICAgOiBwcm9wcy5icmFuZC50b3RhbF9wcm9kdWN0c317JyAnfVxyXG4gICAgICAgICAgcHJvZHVjdHNcclxuICAgICAgICA8L3A+XHJcbiAgICAgIDwvZGl2PlxyXG4gICAgICA8c3R5bGUganN4PlxyXG4gICAgICAgIHtgXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZCB7XHJcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xyXG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgICAgICAgICBmbGV4LXdyYXA6IHdyYXA7XHJcbiAgICAgICAgICAgIHRyYW5zaXRpb246IGFsbCAuNHMgZWFzZTtcclxuICAgICAgICAgICAgb3BhY2l0eTogMTtcclxuICAgICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkOmhvdmVyIHtcclxuICAgICAgICAgICAgb3BhY2l0eTogLjY7XHJcbiAgICAgICAgICB9XHJcblxyXG4gICAgICAgICAgLmJyYW5kLWNhcmQtaW1hZ2Uge1xyXG4gICAgICAgICAgICB3aWR0aDogMzUlO1xyXG4gICAgICAgICAgICBtYXgtd2lkdGg6IDM1JTtcclxuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcclxuICAgICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcclxuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XHJcbiAgICAgICAgICAgIHBhZGRpbmc6IDdweDtcclxuICAgICAgICAgICAgYm9yZGVyOiAxcHggc29saWQgI0Y0RjZGODtcclxuICAgICAgICAgICAgbWF4LWhlaWdodDogNjBweDtcclxuICAgICAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcclxuICAgICAgICAgIH1cclxuXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZC1pbWFnZSBpbWcge1xyXG4gICAgICAgICAgICBtYXgtd2lkdGg6IGNhbGMoMTAwJSAtIDE0cHgpO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkIC5icmFuZC1kZXRhaWwge1xyXG4gICAgICAgICAgICB3aWR0aDogY2FsYyg2NSUgLSAxNnB4KTtcclxuICAgICAgICAgICAgbWF4LXdpZHRoOiBjYWxjKDY1JSAtIDE2cHgpO1xyXG4gICAgICAgICAgICBtYXJnaW4tbGVmdDogMTZweDtcclxuICAgICAgICAgIH1cclxuXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZCAuYnJhbmQtZGV0YWlsIHtcclxuICAgICAgICAgICAgYWxpZ24tc2VsZjogY2VudGVyO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkIC5icmFuZC1uYW1lIHtcclxuICAgICAgICAgICAgZm9udC1mYW1pbHk6IFBvcHBpbnMsIHNhbnMtc2VyaWY7XHJcbiAgICAgICAgICAgIGZvbnQtc3R5bGU6IG5vcm1hbDtcclxuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcclxuICAgICAgICAgICAgZm9udC1zaXplOiAxNnB4O1xyXG4gICAgICAgICAgICBsaW5lLWhlaWdodDogMTZweDtcclxuICAgICAgICAgICAgY29sb3I6ICMwMDA7XHJcbiAgICAgICAgICAgIG1hcmdpbi1ib3R0b206IDhweDtcclxuICAgICAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xyXG4gICAgICAgICAgICBkaXNwbGF5OiBibG9jaztcclxuICAgICAgICAgIH1cclxuXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZCAuYnJhbmQtcHJvZHVjdC10b3RhbCB7XHJcbiAgICAgICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87XHJcbiAgICAgICAgICAgIGZvbnQtc3R5bGU6IG5vcm1hbDtcclxuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcclxuICAgICAgICAgICAgZm9udC1zaXplOiAxNHB4O1xyXG4gICAgICAgICAgICBsaW5lLWhlaWdodDogMTZweDtcclxuICAgICAgICAgICAgY29sb3I6ICM0NTRGNUI7XHJcbiAgICAgICAgICAgIG1hcmdpbjogMDtcclxuICAgICAgICAgIH1cclxuICAgICAgICBgfVxyXG4gICAgICA8L3N0eWxlPlxyXG4gICAgPC9kaXY+XHJcbiAgKVxyXG59XHJcblxyXG5leHBvcnQgZGVmYXVsdCBEZXNrdG9wXHJcbiJdfQ== */\n/*@ sourceURL=desktop.js */"));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "jsx-4284992142" + " " + "brand-card"
    }, /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : props.reviews_url + "/brands/".concat(props.brand.slug, "?tab=products&page=1"),
      className: "jsx-4284992142" + " " + "brand-card-image"
    }, /*#__PURE__*/React.createElement("img", {
      src: !!props.brand_image ? props.brand_image : props.brand.image || 'https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/placeholder-no-brand-logo.png',
      className: "jsx-4284992142"
    })), /*#__PURE__*/React.createElement("div", {
      className: "jsx-4284992142" + " " + "brand-detail"
    }, /*#__PURE__*/React.createElement("a", {
      href: !!props.brand_url ? props.brand_url : props.reviews_url + "/brands/".concat(props.brand.slug, "?tab=products&page=1"),
      id: props.element_id,
      className: "jsx-4284992142" + " " + "brand-name"
    }, !!props.brand_name ? props.brand_name : props.brand.name), /*#__PURE__*/React.createElement("p", {
      className: "jsx-4284992142" + " " + "brand-product-total"
    }, !!props.brand_total_products ? props.brand_total_products : props.brand.total_products, ' ', "products")), /*#__PURE__*/React.createElement(style$1, {
      id: "4284992142"
    }, ".brand-card.jsx-4284992142{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}.brand-card-image.jsx-4284992142{width:41%;max-width:41%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:7px;border:1px solid #F4F6F8;max-height:60px;overflow:hidden;}.brand-card-image.jsx-4284992142 img.jsx-4284992142{max-width:calc(100% - 14px);}.brand-card.jsx-4284992142 .brand-detail.jsx-4284992142{width:calc(59% - 16px);max-width:calc(59% - 16px);margin-left:16px;}.brand-card.jsx-4284992142 .brand-detail.jsx-4284992142{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;}.brand-card.jsx-4284992142 .brand-name.jsx-4284992142{font-family:Poppins,sans-serif;font-style:normal;font-weight:600;font-size:16px;line-height:16px;color:#000;margin-bottom:8px;-webkit-text-decoration:none;text-decoration:none;display:block;}.brand-card.jsx-4284992142 .brand-product-total.jsx-4284992142{font-family:Roboto;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;color:#454F5B;margin:0;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1vYmlsZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0Q1MsQUFHd0IsQUFNRCxBQVlrQixBQUlMLEFBTUwsQUFJYyxBQVliLFVBckNMLENBTkQsUUE0Q0ssSUF0QlMsQ0FmZCxJQVdmLEdBY29CLE1BYUMsWUFaSCxDQVZDLE1BdUJGLFNBWkEsRUFWakIsSUFJQSxBQW1CbUIsU0FaQSxLQWxDRixHQStDRCxTQVpILENBNUJRLElBeUNWLE1BWlMsR0FhcEIsZUFadUIsZ0JBcEN2QixrQ0FxQ2dCLGNBQ2hCLENBL0J5QixtR0FDWCxZQUNhLHlCQUNULGdCQUNBLGdCQUNsQiIsImZpbGUiOiJtb2JpbGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXHJcblxyXG5jb25zdCBNb2JpbGUgPSAocHJvcHMpID0+IHtcclxuICByZXR1cm4gKFxyXG4gICAgPGRpdiBjbGFzc05hbWU9XCJicmFuZC1jYXJkXCI+XHJcbiAgICAgIDxhXHJcbiAgICAgICAgaHJlZj17XHJcbiAgICAgICAgICAhIXByb3BzLmJyYW5kX3VybFxyXG4gICAgICAgICAgICA/IHByb3BzLmJyYW5kX3VybFxyXG4gICAgICAgICAgICA6IHByb3BzLnJldmlld3NfdXJsICtcclxuICAgICAgICAgICAgICBgL2JyYW5kcy8ke3Byb3BzLmJyYW5kLnNsdWd9P3RhYj1wcm9kdWN0cyZwYWdlPTFgXHJcbiAgICAgICAgfVxyXG4gICAgICAgIGNsYXNzTmFtZT1cImJyYW5kLWNhcmQtaW1hZ2VcIlxyXG4gICAgICA+XHJcbiAgICAgICAgPGltZ1xyXG4gICAgICAgICAgc3JjPXtcclxuICAgICAgICAgICAgISFwcm9wcy5icmFuZF9pbWFnZVxyXG4gICAgICAgICAgICAgID8gcHJvcHMuYnJhbmRfaW1hZ2VcclxuICAgICAgICAgICAgICA6IHByb3BzLmJyYW5kLmltYWdlIHx8XHJcbiAgICAgICAgICAgICAgICAnaHR0cHM6Ly9zMy5hcC1zb3V0aGVhc3QtMS5hbWF6b25hd3MuY29tL2Fzc2V0cy5mZW1hbGVkYWlseS5jb20vd2ViLWFzc2V0cy9wbGFjZWhvbGRlci1uby1icmFuZC1sb2dvLnBuZydcclxuICAgICAgICAgIH1cclxuICAgICAgICAvPlxyXG4gICAgICA8L2E+XHJcbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiYnJhbmQtZGV0YWlsXCI+XHJcbiAgICAgICAgPGFcclxuICAgICAgICAgIGhyZWY9e1xyXG4gICAgICAgICAgICAhIXByb3BzLmJyYW5kX3VybFxyXG4gICAgICAgICAgICAgID8gcHJvcHMuYnJhbmRfdXJsXHJcbiAgICAgICAgICAgICAgOiBwcm9wcy5yZXZpZXdzX3VybCArXHJcbiAgICAgICAgICAgICAgICBgL2JyYW5kcy8ke3Byb3BzLmJyYW5kLnNsdWd9P3RhYj1wcm9kdWN0cyZwYWdlPTFgXHJcbiAgICAgICAgICB9XHJcbiAgICAgICAgICBpZD17cHJvcHMuZWxlbWVudF9pZH1cclxuICAgICAgICAgIGNsYXNzTmFtZT1cImJyYW5kLW5hbWVcIlxyXG4gICAgICAgID5cclxuICAgICAgICAgIHshIXByb3BzLmJyYW5kX25hbWUgPyBwcm9wcy5icmFuZF9uYW1lIDogcHJvcHMuYnJhbmQubmFtZX1cclxuICAgICAgICA8L2E+XHJcbiAgICAgICAgPHAgY2xhc3NOYW1lPVwiYnJhbmQtcHJvZHVjdC10b3RhbFwiPlxyXG4gICAgICAgICAgeyEhcHJvcHMuYnJhbmRfdG90YWxfcHJvZHVjdHNcclxuICAgICAgICAgICAgPyBwcm9wcy5icmFuZF90b3RhbF9wcm9kdWN0c1xyXG4gICAgICAgICAgICA6IHByb3BzLmJyYW5kLnRvdGFsX3Byb2R1Y3RzfXsnICd9XHJcbiAgICAgICAgICBwcm9kdWN0c1xyXG4gICAgICAgIDwvcD5cclxuICAgICAgPC9kaXY+XHJcbiAgICAgIDxzdHlsZSBqc3g+XHJcbiAgICAgICAge2BcclxuICAgICAgICAgIC5icmFuZC1jYXJkIHtcclxuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XHJcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XHJcbiAgICAgICAgICAgIGZsZXgtd3JhcDogd3JhcDtcclxuICAgICAgICAgIH1cclxuXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZC1pbWFnZSB7XHJcbiAgICAgICAgICAgIHdpZHRoOiA0MSU7XHJcbiAgICAgICAgICAgIG1heC13aWR0aDogNDElO1xyXG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcclxuICAgICAgICAgICAgcGFkZGluZzogN3B4O1xyXG4gICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAjRjRGNkY4O1xyXG4gICAgICAgICAgICBtYXgtaGVpZ2h0OiA2MHB4O1xyXG4gICAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkLWltYWdlIGltZyB7XHJcbiAgICAgICAgICAgIG1heC13aWR0aDogY2FsYygxMDAlIC0gMTRweCk7XHJcbiAgICAgICAgICB9XHJcblxyXG4gICAgICAgICAgLmJyYW5kLWNhcmQgLmJyYW5kLWRldGFpbCB7XHJcbiAgICAgICAgICAgIHdpZHRoOiBjYWxjKDU5JSAtIDE2cHgpO1xyXG4gICAgICAgICAgICBtYXgtd2lkdGg6IGNhbGMoNTklIC0gMTZweCk7XHJcbiAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAxNnB4O1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkIC5icmFuZC1kZXRhaWwge1xyXG4gICAgICAgICAgICBhbGlnbi1zZWxmOiBjZW50ZXI7XHJcbiAgICAgICAgICB9XHJcblxyXG4gICAgICAgICAgLmJyYW5kLWNhcmQgLmJyYW5kLW5hbWUge1xyXG4gICAgICAgICAgICBmb250LWZhbWlseTogUG9wcGlucywgc2Fucy1zZXJpZjtcclxuICAgICAgICAgICAgZm9udC1zdHlsZTogbm9ybWFsO1xyXG4gICAgICAgICAgICBmb250LXdlaWdodDogNjAwO1xyXG4gICAgICAgICAgICBmb250LXNpemU6IDE2cHg7XHJcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxNnB4O1xyXG4gICAgICAgICAgICBjb2xvcjogIzAwMDtcclxuICAgICAgICAgICAgbWFyZ2luLWJvdHRvbTogOHB4O1xyXG4gICAgICAgICAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XHJcbiAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkIC5icmFuZC1wcm9kdWN0LXRvdGFsIHtcclxuICAgICAgICAgICAgZm9udC1mYW1pbHk6IFJvYm90bztcclxuICAgICAgICAgICAgZm9udC1zdHlsZTogbm9ybWFsO1xyXG4gICAgICAgICAgICBmb250LXdlaWdodDogbm9ybWFsO1xyXG4gICAgICAgICAgICBmb250LXNpemU6IDE0cHg7XHJcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxNnB4O1xyXG4gICAgICAgICAgICBjb2xvcjogIzQ1NEY1QjtcclxuICAgICAgICAgICAgbWFyZ2luOiAwO1xyXG4gICAgICAgICAgfVxyXG4gICAgICAgIGB9XHJcbiAgICAgIDwvc3R5bGU+XHJcbiAgICA8L2Rpdj5cclxuICApXHJcbn1cclxuXHJcbmV4cG9ydCBkZWZhdWx0IE1vYmlsZVxyXG4iXX0= */\n/*@ sourceURL=mobile.js */"));
  };

  var BrandCard = function BrandCard(_ref) {
    var is_mobile = _ref.is_mobile,
        brand = _ref.brand,
        reviews_url = _ref.reviews_url,
        element_id = _ref.element_id,
        brand_image = _ref.brand_image,
        brand_url = _ref.brand_url,
        brand_name = _ref.brand_name,
        brand_slug = _ref.brand_slug,
        brand_total_products = _ref.brand_total_products;
    var props = {
      is_mobile: is_mobile || false,
      brand: brand || {},
      reviews_url: reviews_url || '',
      element_id: element_id || null,
      brand_image: brand_image || null,
      brand_url: brand_url || null,
      brand_name: brand_name || null,
      brand_slug: brand_slug || null,
      brand_total_products: brand_total_products || null
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props);
    }
  };

  var Desktop$1 = function Desktop(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "jsx-1063872515" + " " + "brand-card"
    }, /*#__PURE__*/React.createElement("a", {
      href: props.brand_url ? props.brand_url : "".concat(props.reviews_url, "/brands/").concat(props.brand.slug, "?tab=products&page=1"),
      className: "jsx-1063872515" + " " + "brand-card-image"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.brand_image ? props.brand_image : props.brand.image || "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/placeholder-no-brand-logo.png",
      className: "jsx-1063872515"
    })), /*#__PURE__*/React.createElement(style$1, {
      id: "1063872515"
    }, ".brand-card.jsx-1063872515{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-transition:all .4s ease;transition:all .4s ease;opacity:1;cursor:pointer;}.brand-card.jsx-1063872515:hover{opacity:.6;}.brand-card-image.jsx-1063872515{width:100%;max-width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:7px;border:1px solid #F4F6F8;max-height:89px;overflow:hidden;}.brand-card-image.jsx-1063872515 img.jsx-1063872515{min-width:100%;max-width:calc(100% - 14px);max-height:73px;object-fit:contain;}.brand-card.jsx-1063872515 .brand-detail.jsx-1063872515{width:calc(65% - 16px);max-width:calc(65% - 16px);margin-left:16px;}.brand-card.jsx-1063872515 .brand-detail.jsx-1063872515{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;}.brand-card.jsx-1063872515 .brand-name.jsx-1063872515{font-family:Poppins,sans-serif;font-style:normal;font-weight:600;font-size:16px;line-height:16px;color:#000;margin-bottom:8px;-webkit-text-decoration:none;text-decoration:none;display:block;}.brand-card.jsx-1063872515 .brand-product-total.jsx-1063872515{font-family:Roboto;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;color:#454F5B;margin:0;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlc2t0b3AuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkJJLEFBR3dCLEFBU0EsQUFJQSxBQVlJLEFBT1EsQUFNTCxBQUljLEFBWWIsV0FyRE4sQUFTZixBQUlpQixJQVlhLElBNkJWLElBdEJTLEdBbEJkLEtBNEJLLE1BYUMsTUE3QkgsTUFpQkEsQ0FWQyxNQXVCRixHQTdCSSxNQWlCSixFQVZqQixJQUlBLEFBbUJtQixPQTdCbkIsRUFpQm1CLEtBNUNGLEdBeURELFNBWkgsR0EvQlEsRUE0Q1YsTUFaUyxHQWFwQixlQVp1QixnQkE5Q0csa0NBK0NWLGNBQ2hCLEdBbEN5QixLQWJiLFVBQ0ssZUFDakIscUVBWWMsWUFDYSx5QkFDVCxnQkFDQSxnQkFDbEIiLCJmaWxlIjoiZGVza3RvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIGltcG9ydC9uby1leHRyYW5lb3VzLWRlcGVuZGVuY2llcyAqL1xyXG4vKiBlc2xpbnQtZGlzYWJsZSBqc3gtYTExeS9hbHQtdGV4dCAqL1xyXG4vKiBlc2xpbnQtZGlzYWJsZSByZWFjdC9kZXN0cnVjdHVyaW5nLWFzc2lnbm1lbnQgKi9cclxuLyogZXNsaW50LWRpc2FibGUgcmVhY3QvcHJvcC10eXBlcyAqL1xyXG5pbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XHJcblxyXG5jb25zdCBEZXNrdG9wID0gKHByb3BzKSA9PiAoXHJcblx0PGRpdiBjbGFzc05hbWU9XCJicmFuZC1jYXJkXCI+XHJcblx0XHQ8YVxyXG5cdFx0XHRocmVmPXtcclxuXHRcdFx0XHRwcm9wcy5icmFuZF91cmxcclxuXHRcdFx0XHRcdD8gcHJvcHMuYnJhbmRfdXJsXHJcblx0XHRcdFx0XHQ6IGAke3Byb3BzLnJldmlld3NfdXJsXHJcblx0XHRcdFx0XHR9L2JyYW5kcy8ke3Byb3BzLmJyYW5kLnNsdWd9P3RhYj1wcm9kdWN0cyZwYWdlPTFgXHJcblx0XHRcdH1cclxuXHRcdFx0Y2xhc3NOYW1lPVwiYnJhbmQtY2FyZC1pbWFnZVwiXHJcblx0XHQ+XHJcblx0XHRcdDxpbWdcclxuXHRcdFx0XHRzcmM9e1xyXG5cdFx0XHRcdFx0cHJvcHMuYnJhbmRfaW1hZ2VcclxuXHRcdFx0XHRcdFx0PyBwcm9wcy5icmFuZF9pbWFnZVxyXG5cdFx0XHRcdFx0XHQ6IHByb3BzLmJyYW5kLmltYWdlXHJcbiAgICAgICAgICAgICAgICB8fCBcImh0dHBzOi8vczMuYXAtc291dGhlYXN0LTEuYW1hem9uYXdzLmNvbS9hc3NldHMuZmVtYWxlZGFpbHkuY29tL3dlYi1hc3NldHMvcGxhY2Vob2xkZXItbm8tYnJhbmQtbG9nby5wbmdcIlxyXG5cdFx0XHRcdH1cclxuXHRcdFx0Lz5cclxuXHRcdDwvYT5cclxuXHRcdDxzdHlsZSBqc3g+XHJcblx0XHRcdHtgXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZCB7XHJcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xyXG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgICAgICAgICBmbGV4LXdyYXA6IHdyYXA7XHJcbiAgICAgICAgICAgIHRyYW5zaXRpb246IGFsbCAuNHMgZWFzZTtcclxuICAgICAgICAgICAgb3BhY2l0eTogMTtcclxuICAgICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkOmhvdmVyIHtcclxuICAgICAgICAgICAgb3BhY2l0eTogLjY7XHJcbiAgICAgICAgICB9XHJcblxyXG4gICAgICAgICAgLmJyYW5kLWNhcmQtaW1hZ2Uge1xyXG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcclxuICAgICAgICAgICAgbWF4LXdpZHRoOiAxMDAlO1xyXG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcclxuICAgICAgICAgICAgcGFkZGluZzogN3B4O1xyXG4gICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAjRjRGNkY4O1xyXG4gICAgICAgICAgICBtYXgtaGVpZ2h0OiA4OXB4O1xyXG4gICAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xyXG4gICAgICAgICAgfVxyXG5cclxuICAgICAgICAgIC5icmFuZC1jYXJkLWltYWdlIGltZyB7XHJcbiAgICAgICAgICAgIG1pbi13aWR0aDogMTAwJTtcclxuICAgICAgICAgICAgbWF4LXdpZHRoOiBjYWxjKDEwMCUgLSAxNHB4KTtcclxuICAgICAgICAgICAgbWF4LWhlaWdodDogNzNweDtcclxuICAgICAgICAgICAgb2JqZWN0LWZpdDogY29udGFpbjtcclxuICAgICAgICAgIH1cclxuXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZCAuYnJhbmQtZGV0YWlsIHtcclxuICAgICAgICAgICAgd2lkdGg6IGNhbGMoNjUlIC0gMTZweCk7XHJcbiAgICAgICAgICAgIG1heC13aWR0aDogY2FsYyg2NSUgLSAxNnB4KTtcclxuICAgICAgICAgICAgbWFyZ2luLWxlZnQ6IDE2cHg7XHJcbiAgICAgICAgICB9XHJcblxyXG4gICAgICAgICAgLmJyYW5kLWNhcmQgLmJyYW5kLWRldGFpbCB7XHJcbiAgICAgICAgICAgIGFsaWduLXNlbGY6IGNlbnRlcjtcclxuICAgICAgICAgIH1cclxuXHJcbiAgICAgICAgICAuYnJhbmQtY2FyZCAuYnJhbmQtbmFtZSB7XHJcbiAgICAgICAgICAgIGZvbnQtZmFtaWx5OiBQb3BwaW5zLCBzYW5zLXNlcmlmO1xyXG4gICAgICAgICAgICBmb250LXN0eWxlOiBub3JtYWw7XHJcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiA2MDA7XHJcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTZweDtcclxuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDE2cHg7XHJcbiAgICAgICAgICAgIGNvbG9yOiAjMDAwO1xyXG4gICAgICAgICAgICBtYXJnaW4tYm90dG9tOiA4cHg7XHJcbiAgICAgICAgICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcclxuICAgICAgICAgICAgZGlzcGxheTogYmxvY2s7XHJcbiAgICAgICAgICB9XHJcblxyXG4gICAgICAgICAgLmJyYW5kLWNhcmQgLmJyYW5kLXByb2R1Y3QtdG90YWwge1xyXG4gICAgICAgICAgICBmb250LWZhbWlseTogUm9ib3RvO1xyXG4gICAgICAgICAgICBmb250LXN0eWxlOiBub3JtYWw7XHJcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XHJcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTRweDtcclxuICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDE2cHg7XHJcbiAgICAgICAgICAgIGNvbG9yOiAjNDU0RjVCO1xyXG4gICAgICAgICAgICBtYXJnaW46IDA7XHJcbiAgICAgICAgICB9XHJcbiAgICAgICAgYH1cclxuXHRcdDwvc3R5bGU+XHJcblx0PC9kaXY+XHJcbik7XHJcblxyXG5leHBvcnQgZGVmYXVsdCBEZXNrdG9wO1xyXG4iXX0= */\n/*@ sourceURL=desktop.js */"));
  };

  var titleCase = function titleCase(str) {
    return str.toLowerCase().split(' ').map(function (item) {
      return item.charAt(0).toUpperCase() + item.substring(1);
    }).join(" ");
  };

  var Mobile$1 = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "jsx-1873937866" + " " + "brand-card"
    }, /*#__PURE__*/React.createElement("a", {
      href: props.brand_url ? props.brand_url : "".concat(props.reviews_url, "/brands/").concat(props.brand.slug, "?tab=products&page=1"),
      className: "jsx-1873937866" + " " + "brand-card-image"
    }, titleCase(props.brand_name)), /*#__PURE__*/React.createElement(style$1, {
      id: "1873937866"
    }, ".brand-card.jsx-1873937866{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-transition:all 0.4s ease;transition:all 0.4s ease;opacity:1;cursor:pointer;}.brand-card-image.jsx-1873937866{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background-color:#F9FAFB;padding:8px 12px;max-height:32px;min-width:81px;overflow:hidden;font-size:12px;color:#000;}.brand-card-image.jsx-1873937866 img.jsx-1873937866{min-width:100%;max-width:calc(100% - 14px);height:100%;object-fit:contain;}.brand-card.jsx-1873937866 .brand-detail.jsx-1873937866{width:calc(59% - 16px);max-width:calc(59% - 16px);margin-left:16px;}.brand-card.jsx-1873937866 .brand-detail.jsx-1873937866{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;}.brand-card.jsx-1873937866 .brand-name.jsx-1873937866{font-family:Poppins,sans-serif;font-style:normal;font-weight:600;font-size:16px;line-height:16px;color:#000;margin-bottom:8px;-webkit-text-decoration:none;text-decoration:none;display:block;}.brand-card.jsx-1873937866 .brand-product-total.jsx-1873937866{font-family:Roboto;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;color:#454f5b;margin:0;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=mobile.js */"));
  };

  /* eslint-disable import/no-extraneous-dependencies */

  var BrandCard$1 = function BrandCard(_ref) {
    var is_mobile = _ref.is_mobile,
        brand = _ref.brand,
        reviews_url = _ref.reviews_url,
        element_id = _ref.element_id,
        brand_image = _ref.brand_image,
        brand_url = _ref.brand_url,
        brand_name = _ref.brand_name,
        brand_slug = _ref.brand_slug,
        brand_total_products = _ref.brand_total_products;
    var props = {
      is_mobile: is_mobile || false,
      brand: brand || {},
      reviews_url: reviews_url || "",
      element_id: element_id || null,
      brand_image: brand_image || null,
      brand_url: brand_url || null,
      brand_name: brand_name || null,
      brand_slug: brand_slug || null,
      brand_total_products: brand_total_products || null
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile$1, props);
    }

    return /*#__PURE__*/React.createElement(Desktop$1, props);
  };

  var _excluded = ["type"];
  var Template = [{
    id: "default",
    component: BrandCard
  }, {
    id: "fds",
    component: BrandCard$1
  }];

  var BrandCard$2 = function BrandCard(_ref) {
    var type = _ref.type,
        otherProps = _objectWithoutProperties(_ref, _excluded);

    return Template.filter(function (item) {
      return item.id === type;
    }).map(function (style, idx) {
      return /*#__PURE__*/React.createElement(style.component, _extends({
        key: String(idx)
      }, otherProps));
    });
  };

  BrandCard$2.propTypes = {
    type: propTypes.string
  };
  BrandCard$2.defaultProps = {
    type: "default"
  };

  return BrandCard$2;

})));
//# sourceMappingURL=brand_card.umd.js.map
